function fn_part_carousel() {
    var $fn = $(".part_carousel");
    var $carousel_images = $fn.find("[data-carousel-images]");
    var $carousel_thumbs = $fn.find("[data-carousel-thumbs]");
    if ($fn.length) {
        $carousel_images.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            autoplay: false,
            autoplaySpeed: 3000,
            fade: true,
            cssEase: 'linear',
            asNavFor: $carousel_thumbs
        });
        $carousel_images.on('beforeChange', function(slick){
            $(this).find(".slick-active").next().find("img").addClass("lazyload");
        });

        $carousel_thumbs.slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            asNavFor: $carousel_images,
            dots: false,
            centerMode: false,
            focusOnSelect: true,
            arrows: false,
            lazyLoad: 'ondemand',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3
                    }
                }
            ]
        });
        $carousel_thumbs.on('beforeChange', function(slick){
            $carousel_images.find(".slick-active").find("img").addClass("lazyload");
        });

        $carousel_images.lightGallery({
            thumbnail: true,
            selector: '.elm_carousel_image',
            exThumbImage: 'data-exthumbimage'
        });

        $fn.find("[data-gallery-open]").on("click", function(e){
            e.preventDefault();
            $carousel_images.find(".slick-active").trigger("click");
        });
    }
}